import React from 'react';
import SparkleIcon from './SparkleIcon';

interface ThinkingIndicatorProps {
  agentStatus?: string; // Real-time status from agent tools
}

export const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({ agentStatus }) => {
  // Use agent status or default message
  const displayMessage = agentStatus || 'Thinking...';

  return (
    <div className="flex items-center gap-2 py-2">
      {/* Animated SparkleIcon */}
      <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center">
        <SparkleIcon size={24} color="#06B6D4" animated={true} />
      </div>
      {/* Status message */}
      <p className="text-sm text-slate-600 dark:text-slate-400 font-medium">
        {displayMessage}
      </p>
    </div>
  );
};
